import httpClient from "@/plugins/axios";

export const getWallpapers = async () => {
    const response = await httpClient.get(`/v1/wallpapers/`);
    return response;
}

export const saveWallpaper = async (image) => {
    const data = new FormData();
    data.append('image', image);
    const response = await httpClient.post(`/v1/wallpapers/`, data);
    return response;
}

export const deleteWallpaper = async (id) => {
    const response = await httpClient.delete(`/v1/wallpapers/${id}/`);
    return response;
}

export const sortWallpapers = async (sortedIds) => {
    let query = "?order=" + sortedIds.join("&order=");
    const response = await httpClient.post(`/v1/wallpapers/sort/${query}`)
    return response;
}